import { render, staticRenderFns } from "./payuMethod.vue?vue&type=template&id=cda8e13e&"
import script from "./payuMethod.vue?vue&type=script&lang=js&"
export * from "./payuMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "payuMethod.vue"
export default component.exports